import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';
import { STORAGE_KEY } from '/@/constants/storage';

const recents: AppRouteModule = {
  path: RouteEnum.TASK,
  name: RouteEnum.TASK,
  component: LAYOUT,
  redirect: RouteEnum.TASK_INDEX,
  meta: {
    hideChildrenInMenu: true,
    icon: 'task|svg',
    title: t('routes.task.task'),
    orderNo: 40,
  },
  children: [
    {
      path: 'index',
      name: RouteEnum.TASK_INDEX,
      component: () => import('/@/views/task/taskList/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
        keepAlive: true,
      },
    },
    {
      path: 'config',
      name: RouteEnum.TASK_CONFIG,
      component: () => import('/@/views/task/createTask/index.vue'),
      meta: {
        title: t('routes.task.create'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'detail',
      name: RouteEnum.TASK_DETAIL,
      component: () => import('/@/views/task/taskDetail/manager/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('routes.task.detail'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'detail-worker',
      name: RouteEnum.TASK_DETAIL_WORKER,
      component: () => import('/@/views/task/taskDetail/worker/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('routes.task.detail'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'detail-partner',
      name: RouteEnum.TASK_DETAIL_PARTNER,
      component: () => import('/@/views/task/taskDetail/partner/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('routes.task.detail'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'countdown',
      name: RouteEnum.TASK_COUNTDOWN,
      component: () => import('/@/views/task/taskCountdown/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('routes.task.detail'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'performance',
      name: RouteEnum.TASK_PERFORMANCE,
      component: () => import('/@/views/task/taskPerformance/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('routes.task.detail'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'batch-config-basic',
      name: RouteEnum.TASK_BATCHCONFIG_BASIC,
      component: () => import('/@/views/task/batch-config/basicSettings/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('common.BasicSettings'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'batch-config-ontology',
      name: RouteEnum.TASK_BATCHCONFIG_ONTOLOGY,
      component: () => import('/@/views/task/batch-config/ontology/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('common.ontology'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'batch-config-workflow',
      name: RouteEnum.TASK_BATCHCONFIG_WORKFLOW,
      component: () => import('/@/views/task/batch-config/workflow/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('common.Workflows'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
    {
      path: 'batch-config-qa',
      name: RouteEnum.TASK_BATCHCONFIG_QA,
      component: () => import('/@/views/task/batch-config/QA/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('common.QARules'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.TASK_INDEX,
      },
    },
  ],
};

export default recents;
